import Footer from "../components/Footer";
import NavBar from "../components/Navbar/NavBar";
import ServiceDetail from "../components/ServiceDetail";
import SoftwareImg from "../images/software.png";

export default function SoftwareSolutions() {
  return (
    <>
        <NavBar />
        <ServiceDetail
          titleKey="services.s1_title"
          descriptionKey="services.s1_more"
          image={SoftwareImg}
          highlights={[
              "services.s1_point_1",
              "services.s1_point_2",
              "services.s1_point_3",
          ]}
        />
        <Footer />
    </>
  );
}
